module.exports = __webpack_public_path__ + "8b89535d01193c421e4bc29c4778efef.jpg";